export const headerData = {
  tableName: 'Degree Programs',
  hasExport: false,
  hasPaging: true,
  hasFilter: false,
  hasSearch: false,
  isReverseFilter: false,
  hasTitle: false,
  actionTitle: 'Actions',
  searchWidth: '414px',
  selectWidth: '240px',
  hasInternalSearch: true,
  fields: [
    {
      fieldName: 'parentCategoryText',
      headerName: 'Department',
      isBadge: true,
    },
    {
      fieldName: 'categoryText',
      headerName: 'Degree Program',
      fontSize: 'var(--font-size-18)',
      fontWeight: '500',
    },

    {
      fieldName: 'description',
      headerName: 'Description',
    },
    {
      fieldName: 'categoryCount',
      headerName: 'Lead Count',
      fontSize: 'var(--font-size-18)',
      fontWeight: '600',
    },
  ],
};
